<template>
  <div>
    <main class="w-full h-[90vh] overflow-auto">
      <SitesEditor
        v-if="rsCollection != null"
        :rsCollection="rsCollection"
        :lastExploreTab="lastExploreTab"
      />
    </main>
    <BaseButton
      :icon="'pen'"
      @click="showPage()"
      v-if="userProfile?.UserId === rsCollection?.userId"
      :label="$t('Edit transcription')"
    ></BaseButton>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useSiteStore } from '~/stores/sites'
import SitesEditor from '~/components/Editor-single-page/SitesEditor.vue'

export default {
  components: {
    SitesEditor,
  },
  setup() {
    definePageMeta({
      layout: 'sites',
    })
    const { userProfile } = useKeycloak()
    const sitesStore = useSiteStore()
    return {
      userProfile,
      sitesStore,
    }
  },
  data() {
    return {
      lastExploreTab: null,
    }
  },
  async mounted() {
    if (this.$route.query.lastExploreTab) {
      this.lastExploreTab = this.$route.query.lastExploreTab
    }
    await this.sitesStore.fetchRsCollection(this.url)
  },
  methods: {
    getCurrentPageNr() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)
      return Number(params.get('pageNr')) || Number(params.get('pageid')) || 1
    },
    showPage() {
      let routeData = this.$router.resolve({
        path: `/collection/${this.rsCollection.colId}/doc/${this.docid}/edit`,
        query: { pageNr: this.getCurrentPageNr() },
      })
      window.open(routeData.href, '_blank')
    },
  },
  computed: {
    ...mapState(useSiteStore, ['rsCollection']),
    updateWhenParamsChange() {
      return this.path
    },
    path() {
      return this.$route.path
    },

    url() {
      return this.$route.params.url
    },
    docid() {
      return this.$route.params.docid
    },
  },
}
</script>
